
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9.165","height":"11.732"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 419"}},[_c('g',{attrs:{"data-name":"Groupe 418"}},[_c('g',{attrs:{"data-name":"Groupe 414"}},[_c('path',{attrs:{"data-name":"Tracé 6740","d":"M7.966 11.733H1.2a1.188 1.188 0 01-1.2-1.2v-5.23a1.188 1.188 0 011.2-1.2h6.766a1.188 1.188 0 011.2 1.2v5.206a1.208 1.208 0 01-1.2 1.224zM1.2 5.063a.227.227 0 00-.24.24v5.206a.227.227 0 00.24.24h6.766a.227.227 0 00.24-.24V5.303a.227.227 0 00-.24-.24z","fill":"#fff"}})]),_c('g',{attrs:{"data-name":"Groupe 415"}},[_c('path',{attrs:{"data-name":"Tracé 6741","d":"M7.558 4.535h-1.2v-1.56a1.776 1.776 0 00-3.551 0v1.56H1.608v-1.56a2.975 2.975 0 115.95 0z","fill":"#fff"}})]),_c('g',{attrs:{"data-name":"Groupe 416"}},[_c('circle',{attrs:{"data-name":"Ellipse 74","cx":"1.008","cy":"1.008","r":"1.008","fill":"#fff","transform":"translate(3.575 6.286)"}})]),_c('g',{attrs:{"data-name":"Groupe 417"}},[_c('path',{attrs:{"data-name":"Tracé 6742","d":"M4.583 9.525a.481.481 0 01-.48-.48V7.294a.48.48 0 11.96 0v1.751a.481.481 0 01-.48.48z","fill":"#fff"}})])])])])
          )
        }
      }
    